module.exports = __webpack_public_path__ + "static/media/arrow-left.ccc9eb69.svg";